import React, { useState } from "react";

import "./assets/scss/App.scss";

import CollectionDisplay from "./collection/CollectionDisplay";
import SearchResults from "./search/SearchResults";
import Button from "./modules/Button";

import GraphicWrapper from "./GraphicWrapper";
import GlossaryModal from "./GlossaryModal";
import Credits from "./Credits";

import { useCollectionData } from "./data/DataHooks";

function Widget({ collection }) {
  const [expand, setExpand] = useState(false);


  const defaultSort = collection.Slug == 'suffering-for-art' ?
  {
    field: "debt",
    desc: true,
    title: "Debt, Highest To Lowest"
  } : {
    field: "income",
    desc: true,
    title: "Income, Highest To Lowest"
  }
  const [sortBy, setSortBy] = useState( defaultSort );
  const [selection, setSelection] = useState([1, 2, 3, 4, 5, 6, 7, 8]);

  const order = { field: sortBy.field, direction: sortBy.desc ? "desc" : "asc" };
  const searchResultData = useCollectionData(collection.Dataset, selection, order);

  return (
    <GraphicWrapper className="widget">
      <CollectionDisplay collection={collection} />

      <SearchResults
        searchResultData={searchResultData}
        setSelection={setSelection}
        selection={selection}
        setSortBy={setSortBy}
        sortBy={sortBy}
        limit={expand ?  searchResultData.data.length : 6}
        source={collection.Dataset}
        displayFilters={ searchResultData.data.length > 6 }
      />
    { searchResultData.data.length > 6 &&
      <div style={{ textAlign: "center", margin: "24px 0px" }}>
        {!expand && (
          <Button onClick={() => setExpand(!expand)}>
            &#9662; See All { searchResultData.data.length} Results &#9662;
          </Button>
        )}

        {expand && (
          <Button onClick={() => setExpand(!expand)}>
            &#9652; Collapse &#9652;
          </Button>
        )}
      </div>
    }

      <Credits />

      <GlossaryModal />
    </GraphicWrapper>
  );
}

export default Widget;
